/* eslint-disable react/jsx-no-bind */
import React, { useEffect, useState } from 'react';
import { Table, FlexboxGrid, Schema, Button } from 'rsuite';
import { toast } from 'react-toastify';
import { Container } from '~/styles/tabela';
import api from '~/services/api';
import {
  CelulaEditavel,
  CelulaAcao,
} from '~/components/Celulas/components/CelulaEditavel';
import { Modal1 } from '~/components/ModalCriacao/Modal1';
import { TabelaSemPaginacao } from '~/components/TabelaSemPaginacao';
import { Plus } from '@rsuite/icons';
import { ModalIcon } from '../../../components/ModalCriacao/ModalIcon';
import { Modal2 } from '../../../components/ModalCriacao/Modal2';
import PageHeader from '../../../components/PageHeader';
import Card from '../../../components/Card';

const { HeaderCell, Column } = Table;
const { StringType } = Schema.Types;

const modelo = Schema.Model({
  idioma: StringType().isRequired('Numero Suporte Obrigatório'),
});

function NumerosSuporte() {
  const [dados, setDados] = useState({
    configuracosLista: [],
    configuracosListaFiltrada: [],
    listaInicial: [],
  });
  const [apagarNumeroSuporteDialog, setApagarNumeroSuporteDialog] = useState({
    exibir: false,
    numero: {},
  });
  const [dadosInicial, setDadosInicial] = useState();
  const [carregando, setCarregando] = useState(true);
  const [adicionarNumeroSuporteDialog, setAdicionarNumeroSuporteDialog] = useState(false);
  const [camposInput, setCamposInput] = useState({});


  async function buscarNumerosSuporte() {
    const resposta = await api.get('numeros-suporte');
    const resposta1 = await api.get('numeros-suporte');
    setDados({
      configuracosLista: resposta.data,
      configuracosListaFiltrada: resposta.data,
      listaInicial: resposta1.data,
    })
    setCarregando(false);
  }

  useEffect(() => {
    buscarNumerosSuporte();
  }, []);

  function alterarTextoCelula(id, key, value) {
    const nextData = Object.assign([], dados.configuracosLista);
    nextData.find((item) => item.id === id)[key] = value;
    setDados({ ...dados, configuracosLista: nextData });
  }

  async function alterarEstadoCelula(id) {
    const novaLista = Object.assign([], dados.configuracosLista);
    const item = novaLista.find((config) => config.id === id);
    const itemIncial = dados.listaInicial.find((config) => config.id === id);

    if (item.status === 'EDIT' && item.numero !== itemIncial.numero) {
      try {
        setCarregando(true);
        await api.put(`numeros-suporte/${id}`, item);
        toast.success('Número Suporte atualizado com sucesso');
        buscarNumerosSuporte();
      } catch (error) {
        toast.error(error.message);
      }
      setCarregando(false);
    } else {
      item.status = item.status ? null : 'EDIT';
      setDados({ ...dados, configuracosLista: novaLista });
    }
  }

  function abrirApagarDialog(numero) {
    setApagarNumeroSuporteDialog({
      exibir: true,
      numero,
    });
  }

  function fecharApagarDialog() {
    setApagarNumeroSuporteDialog({
      exibir: false,
      numero: {},
    });
  }

  async function excluirNumeroSuporte() {
    try {
      await api.delete(`/numeros-suporte/${apagarNumeroSuporteDialog.numero.id}`);
      toast.success('Número de suporte excluido com sucesso');
      fecharApagarDialog();
      buscarNumerosSuporte();
    } catch (e) {
      toast.error(e.message);
    }
  }

  async function adicionarNumeroSuporte() {
    try {
      setCarregando(true);
      await api.post(`/numeros-suporte`, camposInput);
      toast.success('Número de suporte criado com sucesso');
      setCarregando(false);
      setAdicionarNumeroSuporteDialog(false);
      buscarNumerosSuporte();
    } catch (e) {
      toast.error(e.message);
    }
  }

  return (
    <Container>
      <PageHeader
        title="Números Suporte"
        subtitle="Gerencie os números de suporte disponíveis no sistema."
        actions={
          <Button
            appearance="primary"
            startIcon={<Plus />}
            onClick={() => setAdicionarNumeroSuporteDialog(true)}
          >
            Novo Número de Suporte
          </Button>
        }
      />
      <Card>
        <TabelaSemPaginacao
          carregando={carregando}
          dados={dados.configuracosLista}
        >
          <Column resizable width={200}>
            <HeaderCell>Ações</HeaderCell>
            <CelulaAcao
              dataKey="id"
              onClick={alterarEstadoCelula}
              onDelete={abrirApagarDialog}
            />
          </Column>
          <Column resizable width={240} sortable>
            <HeaderCell>Telefone</HeaderCell>
            <CelulaEditavel dataKey="numero" onChange={alterarTextoCelula} />
          </Column>

        </TabelaSemPaginacao>
      </Card>
      <Modal1
        show={adicionarNumeroSuporteDialog}
        onHide={() => setAdicionarNumeroSuporteDialog(false)}
        title="Adicionar Número de Suporte"
        label="Número de Suporte"
        name="numero_suporte"
        model={modelo}
        onSubmit={() => adicionarNumeroSuporte()}
        // onSubmit={(status) => status && adicionarNumeroSuporte()}
        onChange={setCamposInput}
        onClick={() => setAdicionarNumeroSuporteDialog(false)}
      />
      <Modal2
        show={apagarNumeroSuporteDialog.exibir}
        onHide={fecharApagarDialog}
        title="Apagar Número de Suporte"
        text="Tem certeza que deseja apagar esse número de suporte?"
        apagarId={apagarNumeroSuporteDialog.numero.id}
        apagarDado={apagarNumeroSuporteDialog.numero.numero}
        fecharApagarDialog={fecharApagarDialog}
        excluir={() => excluirNumeroSuporte()}
      />

    </Container>
  );
}

export default NumerosSuporte;
